import { render, staticRenderFns } from "./InsCmsParentCat.vue?vue&type=template&id=23be6906&scoped=true&"
import script from "./InsCmsParentCat.vue?vue&type=script&lang=ts&"
export * from "./InsCmsParentCat.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsParentCat.vue?vue&type=style&index=0&id=23be6906&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23be6906",
  null
  
)

export default component.exports